function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "\n    cms-idealist-days-map\n  ");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20,38.55h0A3.46,3.46,0,0,1,17.12,37C13.21,31.17,6.65,20.57,6.65,15.15A13.55,13.55,0,0,1,20,1.43,13.55,13.55,0,0,1,33.35,15.15c0,5.42-6.56,16-10.47,21.86A3.46,3.46,0,0,1,20,38.55ZM20,3.68A11.31,11.31,0,0,0,8.9,15.15c0,3.52,3.68,11,10.09,20.61a1.21,1.21,0,0,0,1,.54h0a1.21,1.21,0,0,0,1-.54C27.42,26.18,31.1,18.67,31.1,15.15A11.31,11.31,0,0,0,20,3.68ZM20,22a6.7,6.7,0,0,1-6.68-6.86,6.68,6.68,0,1,1,13.36,0A6.7,6.7,0,0,1,20,22Zm0-11.46a4.47,4.47,0,0,0-4.43,4.6,4.43,4.43,0,1,0,8.86,0A4.47,4.47,0,0,0,20,10.55Z",
  fill: "#231f20"
});

function SvgCmsIdealistDaysMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    viewBox: "0 0 40 40"
  }, props), _ref, _ref2);
}

export default SvgCmsIdealistDaysMap;